import React, { useEffect, useState, useReducer } from "react";
import JsonComponent from "./JsonComponent";
import DatePicker from "react-datepicker";
import { custom_api_call } from "../Api";
import {
  getAllUsers,

} from "api/UsersApi";
import Select from "react-select";

import { getCampaignEmails } from "api/CampaignApi";

import CreatableSelect from "react-select/creatable";

const createOption = (label) => ({
  label,
  value: label.toLowerCase().replace(/\W/g, ''),
});
const Modal_variables = (props) => {
  const [campaignEmailList, setCampaignEmailList] = useState([
    { label: "Please Select", value: "" },
  ]);
  const [isLoading, setIsLoading] = useState(false);
  const [change, setChange] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [variablesData, setvariablesData] = useState([
    { selectedValue: null, dropData: [], variableId: null, valueToShow: null },
  ]);
  const [ignored, forceUpdate] = useReducer((x) => x + 1, 0);
  const [contacts, setContacts] = useState(null);
  const [contactsOptions, setContactsOptions] = useState([]); 
  function refreshPersons(search=null) {
    // if(search){
    //   getAllUsers(0, 50, search)
    //     .then((data) => {
    //       setPersons(data)
    //     })
    //     .catch((e) => { })
    // }
    // else{
    //   getAllUsers(0, 50)
    //     .then((data) => {
    //       setPersons(data)
    //     })
    //     .catch((e) => { })
    // }
  }

  useEffect(() => {
    loadVariablesType();
   
    getAllUsers(50, 0, '').then((users) => {
      users = users.map((u) => {
        return { label: `${u.email}`, value: u.email };
      });
      setContactsOptions(users);
    });

    let emails = [];
    var i = 0;
    getCampaignEmails()
      .then((data) => {
        data.emails.map((email) => {
          i++;
          emails.push({
            label: email,
            value: email,
          });
          if (data.emails.length === i) {
            setCampaignEmailList(emails);
          }
        });
      })

  }, [props.metaDataInfo]);

  const loadVariablesType = () => {
    if (props.metaDataInfo && props.metaDataInfo.variables.length > 0) {
      let temp = [...variablesData];
      props.metaDataInfo.variables.map((obj, id) => {
        temp[id] = { selectedValue: null, dropData: [], variableId: null };
        // check if staticOptions are present, then show them
        if (obj.staticOptions !== null && obj.inputType === "dropdown") {
          temp[id] = {
            ...temp[id],
            dropData: obj.staticOptions,
            variableId: obj.id,
            selectedValue: null,
            valueToShow: null,
            isOptional: obj.isOptional,
          };
          setvariablesData(temp);
          props.handlemodalLoader(false);
          props.ModalType.isediting && presetVariablesValue(temp);
        } else if (
          obj.dependentDataType !== null &&
          obj.inputType !== "dropdown"
        ) {
          temp[id] = {
            ...temp[id],
            dependentDataType: obj.dependentDataType,
            variableId: obj.id,
            isOptional: obj.isOptional,
          };

          setvariablesData(temp);
          props.handlemodalLoader(false);
          props.ModalType.isediting && presetVariablesValue(temp);
        } else if (
          obj.inputType === "dropdown" &&
          obj.implementation !== null
        ) {
          let url = obj.implementation;

          custom_api_call(url.slice(1))
            .then((data) => {
              temp[id]["dropData"] = data;
              temp[id]["variableId"] = obj.id;
              temp[id]["isOptional"] = obj.isOptional;
              setvariablesData(temp);
              forceUpdate();
              props.handlemodalLoader(false);
              props.ModalType.isediting && presetVariablesValue(temp);
            })
            .catch((e) => { })
        } else if (obj.inputType == "textbox" || obj.inputType == "textarea" || obj.inputType == "json" || obj.inputType == "checkbox" || obj.inputType == "verifiedEmailsDropdown") {
          temp[id] = {
            ...temp[id],
            variableId: obj.id,
            selectedValue: null,
            isOptional: obj.isOptional,
          };
          setvariablesData(temp);
          props.handlemodalLoader(false);
        }

      });
      props.ModalType.isediting && presetVariablesValue(temp);
    }
  };

  const presetVariablesValue = (filter_data) => {

    function setValues(data, id) {
      let temp = [...filter_data];
      let tempdict = {};

      if (props.ModalType.isediting == true) {
        props.ModalType.variables && props.ModalType.variables.map((obj) => {
          tempdict[obj.variableId] = {
            value: obj.value,
            valueToShow: obj.valueToShow,
          };
        })

        temp.map((obj) => {
          obj.selectedValue = tempdict[obj.variableId] && tempdict[obj.variableId].value;
          obj.valueToShow = tempdict[obj.variableId] && tempdict[obj.variableId].valueToShow;
        })
      }

      setvariablesData(temp);
      props.variables_data(temp);
    }
    if (props.ModalType && props.ModalType.isAction) {
      setValues(props.ModalType.variables, "action");
      props.handlemodalLoader(false);
    } else {
      setValues(props.ModalType.variables, "not action");
      props.handlemodalLoader(false);
    }
  };

  const DateTime = (idx) => {
    let temp = [...variablesData];
    return (
      <DatePicker
        selected={startDate}
        onChange={(date) => {
          let key = "selectedValue";
          let value = date;
          temp[idx["idx"]][key] = value;
          setvariablesData(temp);
          props.variables_data(temp);
          setStartDate(date);
        }}
        showTimeSelect
        dateFormat="MMMM d, yyyy h:mm aa"
      />
    );
  };


  const updateVariableData = (idx, data) => {
    let temp = [...variablesData];
    if (temp[idx]) {
      const processedJson = {}
      data.map(obj => {
        processedJson[obj['input1']] = obj['input2']
      })
      temp[idx]["selectedValue"] = JSON.stringify(processedJson);
      setvariablesData(temp);
      props.variables_data(temp);
    }
  }

  const Date_Comp = (idx) => {
    let temp = [...variablesData];
    let currentIdx = idx["idx"];
    let date = new Date(temp && temp[currentIdx]?.["selectedValue"]);
    return (
      <DatePicker
        selected={temp[currentIdx]?.["selectedValue"] && date}
        onChange={(date) => {
          let key = "selectedValue";
          let value = date;

          temp[currentIdx][key] = value;
          setvariablesData(temp);
          props.variables_data(temp);
        }}
        dateFormat="MMMM d, yyyy"
        placeholderText="Select a date"
      />
    );
  };


  const handleInputChange = (inputValue, actionMeta) => {

    if (inputValue) {
      getAllUsers(100, 0, inputValue).then((users) => {
        users = users.map((u) => {
          return { label:`${u.email}`, value: u.email };
        });
        setContactsOptions(users);
      });
    }
  };
  const handleChange = (newValue, actionMeta) => {
    setChange(true);
    setContacts(newValue);
  };
  const handleCreate = (inputValue) => {
    setChange(true);
    setIsLoading(true);
    setTimeout(() => {
      const newOption = createOption(inputValue);
      setContacts(newOption);
      setIsLoading(false);
    }, 1000);
  };

  return (
    <>
      <div>
        {/* Variables */}
        {props.metaDataInfo.serviceName == "WaitService" ? <h4 className="h4">Max Wait Time:</h4> : (
          ""
        )}
        <div className="variables">
          {props.metaDataInfo &&
            props.metaDataInfo.variables &&
            props.metaDataInfo.variables.map((c, idx) => {
              let fieldToShow = c.fieldToShow || "name";
              let fieldToSave = c.fieldToSave || "id";
              console.log(c)
              if (c.inputType == 'verifiedEmailsDropdown' && variablesData[idx] && !contacts  && variablesData[idx].selectedValue ){
                console.log("customPersonDropdown", variablesData[idx], c, variablesData)
                setContacts({ label: variablesData[idx].selectedValue, value: variablesData[idx].selectedValue })
              }

              return (
                <div className="variables-map">
                  <div className="variables_label">
                    <label>
                      {c.label}
                      {!c.isOptional ? "*" : ""}
                      {":"}
                    </label>
                  </div>
                  {c.inputType == 'verifiedEmailsDropdown' ?
                           <div
                      style={{
                        width: '200px',
                        marginLeft: '7px' }}
                           >
                            {/* {
                        variablesData[idx] && variablesData[idx].selectedValue && setContacts(variablesData[idx].selectedValue)
                            } */}
                      <Select
                        id="audId"
                        isClearable
                        formatCreateLabel={() => undefined}
                        value={{
                          value: variablesData[idx] ? variablesData[idx].selectedValue :"",
                          label: variablesData[idx] ?variablesData[idx].selectedValue:"",
                        }}
                        onChange={(e, { action }) => {
                          let temp = [...variablesData];
                          temp[idx].selectedValue = e.value;
                          temp[idx].valueToShow = e.value;
                          setvariablesData(temp);
                          props.variables_data(temp);
                        }}
                        options={campaignEmailList}
                        required
                      />
                      {/* <CreatableSelect
                        isMulti={false}
                        // formatCreateLabel={() => undefined}
                        // onChange={handleChangeTags}
                        onInputChange={handleInputChange}
                        value={contacts}
                        placeholder={''}
                        onChange={(newValue, actionMeta) => {
                          


                          handleChange(newValue, actionMeta);
                        
                                                    let temp = [...variablesData];
                          temp[idx].selectedValue = newValue.value;
                          temp[idx].valueToShow = newValue.value;
                          setvariablesData(temp);
                          props.variables_data(temp);
                        }}
                        onCreateOption={(inputValue) => { handleCreate(inputValue);
                          let temp = [...variablesData];
                          temp[idx].selectedValue = inputValue;
                          temp[idx].valueToShow = inputValue;
                          setvariablesData(temp);
                          props.variables_data(temp);
                        
                        
                        }}
                        isDisabled={isLoading}
                        isLoading={isLoading}
                        // styles={customStyles}
                        options={contactsOptions}
                      /> */}
                           </div>
                  :
                  
                  c.inputType === "dropdown" ? (
                    <div>
                      <select
                        required
                        onChange={(e) => {
                          let id = e.target.value;
                          if (id != -1) {
                            let sequence = e.target.selectedIndex - 1;
                            let temp = [...variablesData];
                            temp[idx] = {
                              ...temp[idx],
                              selectedValue: id,
                              valueToShow:
                                variablesData[idx].dropData[sequence][
                                fieldToShow
                                ],
                            };
                            setvariablesData(temp);
                            props.variables_data(temp);
                          } else {

                            let temp = [...variablesData];
                            temp[idx] = {
                              ...temp[idx],
                              selectedValue: id,
                              valueToShow: "Select",
                            };
                            setvariablesData(temp);
                            props.variables_data(temp);
                          }
                        }}
                        value={
                          variablesData[idx] && variablesData[idx].selectedValue
                        }
                      >
                        <option id="0" value={-1}>
                          Select
                        </option>

                        {variablesData[idx] &&
                          variablesData[idx]?.dropData &&
                          variablesData[idx]?.dropData?.map((obj, id) => {
                            return (
                              <option
                                key={id}
                                id={id}
                                value={
                                  obj[fieldToSave]
                                }
                              >
                                {obj[fieldToShow]}
                              </option>
                            );
                          })}
                      </select>

                      <br />
                    </div>
                  ) : variablesData[idx] &&
                    variablesData[idx].dependentDataType ? (
                    variablesData[idx].dependentDataType.dataType[
                      variablesData[c.dependentDataType.sno].selectedValue
                    ] &&
                      variablesData[idx].dependentDataType.dataType[
                      variablesData[c.dependentDataType.sno].selectedValue
                      ] === "datetime" ? (
                      <div>
                        <DateTime idx={idx} />
                      </div>
                    ) : (
                      <div>
                        <input
                          name={""}
                          id="input1"
                          title=""
                          type={
                            variablesData[idx].dependentDataType.dataType[
                              variablesData[c.dependentDataType.sno]
                                .selectedValue
                            ] &&
                              variablesData[idx].dependentDataType.dataType[
                              variablesData[c.dependentDataType.sno]
                                .selectedValue
                              ] === "integer"
                              ? "text"
                              : "text"
                          }
                          value={
                            variablesData[idx] &&
                            variablesData[idx].selectedValue
                          }
                          onChange={(e) => {
                            let temp = [...variablesData];
                            temp[idx].selectedValue = e.target.value;
                            temp[idx].valueToShow = e.target.value;
                            setvariablesData(temp);
                            props.variables_data(temp);
                          }}
                        // required
                        />
                      </div>
                    )
                  )
                   :c.inputType == "checkbox" ? (
                  <div>
                    {/* if dependentdataType is not present then it is a text value */}
                    <input
                      // required
                      type="checkbox"
                      title=""
                      onChange={(e) => {
                        let temp = [...variablesData];
                        temp[idx].selectedValue = e.target.checked;
                        temp[idx].valueToShow = e.target.checked;
                        setvariablesData(temp);
                        props.variables_data(temp);
                      }}
                      value={
                        variablesData[idx] && variablesData[idx].selectedValue
                      }
                    />
                    <br />
                  </div>
                ) 
                  
                  
                  
                  : c.inputType == "textarea" ? (
                    <div>
                      {/* if dependentdataType is not present then it is a text value */}
                      <textarea
                        // required
                        type="text"
                        title=""
                        onChange={(e) => {
                          let temp = [...variablesData];
                          temp[idx].selectedValue = e.target.value;
                          temp[idx].valueToShow = e.target.value;
                          setvariablesData(temp);
                          props.variables_data(temp);
                        }}
                        value={
                          variablesData[idx] && variablesData[idx].selectedValue
                        }
                      />
                      <br />
                    </div>
                  ) : c.dataType == "date" ? (
                    <div>
                      <Date_Comp idx={idx} />
                    </div>
                  ) : c.inputType == "json" ? <JsonComponent variableIdx={idx} updateVariableData={updateVariableData} variablesData={variablesData} value={
                    variablesData[idx] && variablesData[idx].selectedValue
                  } isEditing={props.ModalType.isediting} /> : (
                    <div>
                      {/* if dependentdataType is not present then it is a text value */}
                      <input
                        type="text"
                        title=""
                        onChange={(e) => {
                          let temp = [...variablesData];
                          temp[idx].selectedValue = e.target.value;
                          temp[idx].valueToShow = e.target.value;
                          setvariablesData(temp);
                          props.variables_data(temp);
                        }}
                        value={
                          variablesData[idx] && variablesData[idx].selectedValue
                        }
                      />
                      <br />
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default Modal_variables;
